exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usuarios-ppap .limit-container {\n  background-color: white;\n  box-shadow: 0px 0px 10px 1px #dbd9d8;\n  margin: 3rem 0;\n  padding: 5%; }\n\n.usuarios-ppap .spinner-position {\n  position: absolute;\n  z-index: 10000;\n  width: 81%;\n  margin-top: 14%; }\n  .usuarios-ppap .spinner-position small {\n    display: block; }\n\n.usuarios-ppap .update-button .fa-spinner {\n  font-size: 20px;\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/risks-module/risks-module.component.scss
// module id = ../../../../../src/app/components/risks-module/risks-module.component.scss
// module chunks = main